module.exports = __webpack_public_path__ + "static/media/sylvie.8d362c03.jpg";